/**
 * Service Category Icons Configuration
 * Maps service categories to Material-UI icons for visual identification
 * Used across Penta Uni Platform for better user experience
 */

import {
  DirectionsCar,
  LocalHospital,
  School,
  Work,
  Home,
  ChildCare,
  Category,
  Build,
  Computer,
  ShoppingCart,
  AccessibleForward,
  AccountBalance,
  HelpOutline
} from '@mui/icons-material';

// Map category names to icon components and colors
export const SERVICE_CATEGORY_ICONS = {
  'Transportation': {
    name: 'Transportation',
    icon: DirectionsCar,
    color: '#2196F3', // blue
    description: 'Rides, carpools, and transportation assistance'
  },
  'Home Repair': {
    name: 'Home Repair',
    icon: Build,
    color: '#FF9800', // orange
    description: 'Home repairs, maintenance, and household fixes'
  },
  'Technology Help': {
    name: 'Technology Help',
    icon: Computer,
    color: '#9C27B0', // purple
    description: 'Tech support, computer help, and digital assistance'
  },
  'Education/Tutoring': {
    name: 'Education/Tutoring',
    icon: School,
    color: '#4CAF50', // green
    description: 'Tutoring, classes, and educational support'
  },
  'Healthcare Support': {
    name: 'Healthcare Support',
    icon: LocalHospital,
    color: '#F44336', // red
    description: 'Medical assistance, appointments, and health services'
  },
  'Shopping/Errands': {
    name: 'Shopping/Errands',
    icon: ShoppingCart,
    color: '#00BCD4', // cyan
    description: 'Grocery shopping, errands, and pickup services'
  },
  'Childcare': {
    name: 'Childcare',
    icon: ChildCare,
    color: '#E91E63', // pink
    description: 'Babysitting, childcare, and family support'
  },
  'Elder Care': {
    name: 'Elder Care',
    icon: AccessibleForward,
    color: '#795548', // brown
    description: 'Elder care, companionship, and senior support'
  },
  'Professional Services': {
    name: 'Professional Services',
    icon: Work,
    color: '#3F51B5', // indigo
    description: 'Professional skills, consulting, and business services'
  },
  'Religious Services': {
    name: 'Religious Services',
    icon: AccountBalance,
    color: '#009688', // teal
    description: 'Religious education, guidance, and spiritual support'
  },
  'Other': {
    name: 'Other',
    icon: Category,
    color: '#607D8B', // blue-grey
    description: 'Other community services and assistance'
  }
};

/**
 * Get icon configuration for a service category
 * Returns default "Other" config if category not found
 */
export function getServiceCategoryIcon(category) {
  return SERVICE_CATEGORY_ICONS[category] || SERVICE_CATEGORY_ICONS.Other;
}

/**
 * Get all available service categories
 */
export function getAllServiceCategories() {
  return Object.keys(SERVICE_CATEGORY_ICONS);
}

/**
 * Check if a category exists in the configuration
 */
export function isValidServiceCategory(category) {
  return category in SERVICE_CATEGORY_ICONS;
}

export default SERVICE_CATEGORY_ICONS;
